<template>
  <v-container>
    <router-link to="/customer">{{ $t('home.text.customer') }}</router-link>
  </v-container>
</template>

<script>
import { withLang } from '@/i18n-route'

export default {
  name: 'Home',
  components: {},
  beforeRouteEnter(to, from, next) {
    // withLang: a guard's next() bypasses wrapNavigation, so the locale has
    // to be carried by hand here - see withLang() for why.
    next(
      withLang(
        { path: '/timeline', query: { autoDetectShop: true } },
        to.params.lang
      )
    )
  },
}
</script>
